import React, { useEffect, useState } from "react";
import { FiArrowLeft, FiChevronRight, FiX } from "react-icons/fi";
import LangLink from "../../LangLink";
import { useSwitchLanguage } from "../../../../hooks/useLanguageRouting";
import { normalizeLanguage } from "../../../../utils/languageRouting";
import "./MobileNav.css";

const menuItems = [
  { id: "about", key: "aboutUs", hasChildren: true },
  { id: "products", key: "products", to: "/products" },
  { id: "solutions", key: "solutions", to: "/allsolutions" },
  { id: "services", key: "services", to: "/services" },
  { id: "sectors", key: "sectors", to: "/sectors" },
  { id: "projects", key: "projects", to: "/allprojects" },
  { id: "estimator", key: "estimator", to: "/estimator" },
];

const aboutLinks = [
  { id: "whoWeAre", to: "/about", highlight: true },
  { id: "academy", to: "/academy" },
  { id: "careers", to: "/careers" },
  { id: "downloads", to: "/downloads" },
  { id: "blog", to: "/blog" },
  { id: "contactUs", to: "/contactus" },
];

const MobileNav = ({ isOpen, onClose, onRequestCall, t, i18n }) => {
  const [activeMenu, setActiveMenu] = useState("main");
  const switchLanguage = useSwitchLanguage();
  const activeLang = normalizeLanguage(i18n.language);

  useEffect(() => {
    if (!isOpen) {
      setActiveMenu("main");
    }
  }, [isOpen]);

  return (
    <div className={`mobile-nav ${isOpen ? "mobile-nav--open" : ""}`}>
      <div className="mobile-nav__top">
        {activeMenu === "main" ? (
          <h2>{t("navbar.menu")}</h2>
        ) : (
          <button
            type="button"
            className="mobile-nav__back"
            onClick={() => setActiveMenu("main")}
          >
            <FiArrowLeft />
            <span>{activeMenu === "about" ? t("navbar.aboutUs") : t("navbar.menu")}</span>
          </button>
        )}

        <button
          type="button"
          className="mobile-nav__close"
          onClick={onClose}
          aria-label="Close mobile menu"
        >
          <FiX />
        </button>
      </div>

      {activeMenu === "main" ? (
        <ul className="mobile-nav__links">
          {menuItems.map((item) => (
            <li key={item.id}>
              {item.hasChildren && item.id === "about" ? (
                <button
                  type="button"
                  className="mobile-nav__itemButton"
                  onClick={() => setActiveMenu("about")}
                >
                  <span>{t(`navbar.${item.key}`)}</span>
                  <FiChevronRight className="mobile-nav__icon" />
                </button>
              ) : item.to ? (
                <LangLink to={item.to} onClick={onClose} className="mobile-nav__itemLink">
                  <span>{t(`navbar.${item.key}`)}</span>
                  {item.hasChildren && <FiChevronRight className="mobile-nav__icon" />}
                </LangLink>
              ) : (
                <button type="button" className="mobile-nav__itemButton">
                  <span>{t(`navbar.${item.key}`)}</span>
                  {item.hasChildren && <FiChevronRight className="mobile-nav__icon" />}
                </button>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <ul className="mobile-nav__links mobile-nav__links--submenu">
          {aboutLinks.map((item) => (
            <li key={item.id}>
              <LangLink
                to={item.to}
                onClick={onClose}
                className={`mobile-nav__subLink ${item.highlight ? "is-highlight" : ""}`}
              >
                {t(`navbar.aboutMenu.${item.id}`)}
              </LangLink>
            </li>
          ))}
        </ul>
      )}

      <div className="mobile-nav__bottom">
        <div className="mobile-nav__languageTabs">
          {[
            { code: "en", labelKey: "langEn" },
            { code: "ar", labelKey: "langAr" },
            { code: "ku", labelKey: "langKu" },
          ].map((lang) => (
            <button
              type="button"
              key={lang.code}
              className={activeLang === lang.code ? "is-active" : ""}
              onClick={() => switchLanguage(lang.code)}
            >
              {t(`navbar.${lang.labelKey}`)}
            </button>
          ))}
        </div>
        <button className="buttongyp mobile-nav__requestBtn" onClick={onRequestCall}>
          {t("navbar.requestCall")}
        </button>
      </div>
    </div>
  );
};

export default MobileNav;
